import { PlanDetailPage } from '@/features/plans/pages/plan-detail-page';

const PlanDetailRoute = () => {
  return <PlanDetailPage />;
};

export default PlanDetailRoute;
